<div class="office-header">
  <div class="office-header__content">
    <div class="office-header__text">
      <h2 class="office-header__platform-name">WIPO ADR Online Case Management System (OCMS)</h2>
      <h3 class="office-header__office-name">{{ officeName | uppercase }}</h3>
    </div>
    <div class="office-header__logo">
      @if (!logoLoadError) {
        <img [src]="logoImageUrl" (error)="logoLoadError = true" [alt]="officeName + ' Logo'">
      }
    </div>
  </div>
</div>
